<template>
  <div v-if="show" class="c-cookies-popup">
    <button
        type="button"
        class="ui-button relative default mr-4 text-dark-content"
        @click="accept"
    >
      <div class="opacity-100 ui-button__content">Принять</div>
    </button>
    <p class="text-3_5" v-html="$t('cookie.text')" />
  </div>
</template>

<script>
export default {
  name: "CookiePopup",
  data() {
    return {
      show: !localStorage.getItem("cookieAccepted")
    };
  },
  methods: {
    accept() {
      localStorage.setItem("cookieAccepted", "1");
      this.show = false;
    }
  }
};
</script>

<style>
.c-cookies-popup {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background: #222;
  color: #fff;
  padding: 24px 32px;
  display: flex;
  align-items: flex-start;
  z-index: 9999;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.2);
  flex-direction: row;
}
.ui-button {
  min-width: 130px;
  min-height: 48px;
  font-size: 1.1em;
  font-weight: bold;
  background: #fff;
  color: #222;
  border: none;
  border-radius: 7px;
  margin-right: 24px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  box-shadow: 0 2px 7px 0 rgba(0,0,0,0.08);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ui-button__content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ui-button:hover {
  background: #eee;
  color: #1976d2;
}
.text-dark-content {
  color: #222 !important;
}
.text-3_5 {
  font-size: 1.15rem;
  line-height: 1.55;
  margin: 0;
  text-align: left;
  word-break: break-word;
}
.c-cookies-popup a {
  color: #90caf9;
  text-decoration: underline;
  font-weight: 500;
}

/* MOBILE: кнопка всегда по середине текста по высоте */
@media (max-width: 700px) {
  .c-cookies-popup {
    flex-direction: row;
    align-items: center;
    padding: 16px 10px;
  }
  .ui-button {
    margin-right: 12px;
    margin-bottom: 0;
    width: 110px;
    min-height: 44px;
    font-size: 1em;
  }
  .text-3_5 {
    font-size: 1em;
  }
}
</style>